import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import MessageComponent from './Messages';
import SubscriptionPlans from './SubscriptionPlan';
import BoostJobComponent from './BoostJob';
import Loader from "./Loader";
import BASE_URL from "../context/AppConfig";


const WorkerList = ({workerId, userId}) => {
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate();
  const handleViewDetails = (workerId) => {
    navigate(`/workers/${workerId}`);
  };
  

  // Fetch workers from the backend
  const token = localStorage.getItem("token") ? localStorage.getItem("token"): null;
  useEffect(() => {
    
      axios
      .get(`${BASE_URL}/workers-list/`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },}
      )
      .then((response) => {
        setWorkers(response.data);
        setLoading(false);
        
      })
      .catch((error) => {
        setError("Failed to load workers. Please try again.");
        setLoading(false);
      });


      
    
    
  }, []);

  return (
    <>
    
    <div className="container mt-5">
      <h2 className="text-center mb-4">Available Workers</h2>

      {/* Error Handling */}
      {error && <div className="alert alert-danger">{error}</div>}

      {/* Loading State */}
      {loading ? (
        // <div className="text-center">
        //   <div className="spinner-border text-primary" role="status">
        //     <span className="visually-hidden">Loading...</span>
        //   </div>
        // </div>
        <Loader/>
      ) : (
        <div className="row">
          {workers.map((worker) => (
            <div className="col-md-4 mb-4" key={worker.id}>
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">{`${worker.name} (${worker.worker_id})`}</h5>
                  <p className="card-text">
                    <strong>Job Role:</strong> {worker.job_role}
                  </p>
                  <p className="card-text">
                    <strong>Work Site:</strong> {worker.worksite}
                  </p>
                  
                  <button className="btn btn-primary btn-sm" >
                    Download QR Code
                  </button>
                  <button
                      className="btn btn-success btn-sm ms-2"
                      onClick={() => handleViewDetails(worker.worker_id)}
                    >
                      View Details
                    </button>
                  
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
    </>
  );
};

export default WorkerList;
